import { createAPIModule } from 'utility/redux/apiModuleHelpers';
import flexSaga from 'utility/redux/saga/flexSaga';
import idpClient from 'utility/redux/saga/idpClient';

const getStateSlice = (state) => state.openid.authorize;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'OPENID_AUTHORIZE',
	url: 'authorize',
	client: flexSaga(idpClient),
	prefix: 'openid',
});

export { actions, reducer, sagas, selectors };
